import React from "react";
import Routes from "./index";

const RoutesWrapper: React.FC = () => {

  return (
    <div>
      <Routes />
    </div>
  );
};

export default RoutesWrapper;
